module.exports = __webpack_public_path__ + "img/os_icon_case@2x.f6faad0f.png";